<template>
  <div class="featured-dorms__list dorm-card__list user__list-wrp istatistik">
    <container class="gen-container">
      <DormDashboardHead
        :first-name="first_name"
        :last-name="last_name"
        :logo="dormLogo"
        :mail="mail1"
      ></DormDashboardHead>
      <div class="status-bar row">
        <div class="col col-6 col-xs-12">#{{ detail.id }}</div>
        <div class="col col-6 col-xs-12 d-flex justify-content-end">
          <b class="text-muted">Durum:&nbsp;</b>
          <span class="text-warning" v-if="detail.is_approved === 0"
            >Bekliyor</span
          >
          <span class="color-light-green" v-if="detail.is_approved === 1"
            >Onaylandı</span
          >
          <span class="text-danger" v-if="detail.is_approved === 2"
            >Reddedildi</span
          >
        </div>
      </div>
      <div class="user__list-offer row reservation-detail">
        <div class="col col-12 reservation-detail-head">
          <div class="row">
            <div
              class="col col-4 col-xs-12 text-center d-flex flex-column align-items-start"
            >
              <b class="color-light-green">Oluşturma T:</b>
              {{ formatDatetime(detail.created_at) }}
            </div>
            <div class="col col-4 col-xs-6 text-center">
              <b class="color-light-green">{{ detail.reserved_capacity }}</b>
              Kişi <br />
              <div v-html="totalDay(detail.start_date, detail.end_date)"></div>
            </div>
            <div
              class="col col-4 col-xs-6 text-center d-flex justify-content-center align-items-end flex-column"
            >
              <div>
                <b class="color-light-green">Giriş:</b>
                {{ formatDatetime(detail.start_date) }}
              </div>
              <div>
                <b class="color-light-green">Çıkış:</b>
                {{ formatDatetime(detail.end_date) }}
              </div>
            </div>
          </div>
        </div>
        <div class="col col-6 col-xs-12">
          <div class="reservation-card">
            <div class="text-muted"><b>#</b>{{ detail.user.id }}</div>
            <div>
              <b class="color-light-green">İsim: </b>{{ detail.user.name }}
            </div>
            <div>
              <b class="color-light-green">Email: </b>{{ detail.user.email }}
            </div>
            <div>
              <b class="color-light-green">Tel: </b>{{ detail.user.phone }}
            </div>
          </div>
        </div>
        <div class="col col-6 col-xs-12">
          <div class="reservation-card">
            <div>
              <b class="color-light-green">Başlık: </b>{{ detail.room.title }}
            </div>
            <div>
              <b class="color-light-green">Günlük Fiyat: </b
              >{{ detail.room.daily_price }} TL
            </div>
            <div>
              <b class="color-light-green">Toplam Kapasite: </b
              >{{ detail.room.capacity }} Kişi
            </div>
            <div>
              <b class="color-light-green">Boyut: </b
              >{{ detail.room.size }} m<sup>2</sup>
            </div>
          </div>
        </div>
        <div class="col col-12 col-xs-12">
          <form>
            <div class="reservation-card mb-15">
              <v-input
                placeholder="Mesaj"
                type="textarea"
                rows="5"
                :value="form.message"
                @input="form.message = $event"
                auto-complete="on"
                name="message"
                minlength="3"
                maxlength="255"
                required
              />
            </div>

            <div
              class="reservation-actions mb-20 row"
              v-if="detail.is_approved === 0"
            >
              <div class="col col-6 col-xs-12">
                <v-button
                  size="sm"
                  type="button"
                  class="light-green btn-block"
                  title="Onayla"
                  @click="accept"
                />
              </div>
              <div class="col col-6 col-xs-12">
                <v-button
                  size="sm"
                  type="button"
                  class="red btn-block"
                  title="Reddet"
                  @click="reject"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </container>
  </div>
</template>

<script>
import DormDashboardHead from '@/components/Dorm/DormDashboardHead.vue'
import { formatDate, getTotalDays } from '@/utils/date'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'DormRoomReservationDetailView',
  components: {
    DormDashboardHead
  },
  metaInfo() {
    return {
      title: 'Rezervasyon Detayı'
    }
  },
  data() {
    return {
      logo: null,
      dormLogo: null,
      mail: '',
      detail: {
        user: {},
        room: {}
      },
      form: {
        message: ''
      }
    }
  },
  computed: {
    ...mapGetters(['first_name', 'last_name', 'phone', 'mail1'])
  },
  methods: {
    async accept() {
      this.$loading('Onaylanıyor...')
      const resp = await axios
        .post(
          `/dorm/room/reservation/${this.$route.params.reservationId}/approve`,
          { message: this.form.message }
        )
        .catch(() => ({ data: {}, status: 400 }))
      this.$loading.close()
      if (resp.status === 200) {
        this.$toast.center('Rezervasyon onaylandı')
        this.$router.push(
          `/yurt-yonetimi/yurtlar/odalar/${this.$route.params.id}/rezervasyonlar`
        )
      } else {
        this.$toast.center('Bir hata oluştu')
      }
    },
    async reject() {
      this.$loading('Reddediliyor...')
      const resp = await axios
        .post(
          `/dorm/room/reservation/${this.$route.params.reservationId}/reject`,
          { message: this.form.message }
        )
        .catch(() => ({ data: {}, status: 400 }))
      this.$loading.close()
      if (resp.status === 200) {
        this.$toast.center('Rezervasyon reddedildi')
        this.$router.push(
          `/yurt-yonetimi/yurtlar/odalar/${this.$route.params.id}/rezervasyonlar`
        )
      } else {
        this.$toast.center('Bir hata oluştu')
      }
    },
    formatDatetime(date) {
      return formatDate(date)
    },
    totalDay(start, end) {
      const day = getTotalDays(start, end)
      return `<span class="color-light-green">${day +
        1}</span> Gece <span class="color-light-green">${day}</span> Gün`
    },
    async getReservationDetail() {
      const res = await axios
        .get(`/dorm/room/reservations/${this.$route.params.reservationId}`)
        .catch(() => ({ data: {} }))
      this.detail = res.data
      if (res.data && res.data.message) {
        this.form.message = res.data.message
      }
    }
  },
  mounted() {
    this.mail = window.localStorage.getItem('mail')
    this.username = window.localStorage.getItem('username')
  },
  created() {
    this.dormLogo = window.localStorage.getItem('cache:dorm_logo')
    this.getReservationDetail()
  }
}
</script>

<style lang="scss" scoped>
.reservation-detail {
  background-color: white;
  border-radius: 10px;
  &-head {
    padding: 20px 25px;
    border-bottom: 1px solid #e5e5e5;
  }
  &-card {
  }
  .reservation-card {
    background-color: #f5f5f5;
    padding: 15px;
    border-radius: 10px;
    margin-top: 15px;
    div {
      margin-bottom: 5px;
    }
  }
}

.status-bar {
  margin-bottom: 15px;
  margin-top: 15px;
}
</style>
